export function getPreviewErrorMessage(error: unknown): string {
  const statusCode = getErrorStatusCode(error);
  if (statusCode === 424) {
    return 'This canvas is not ready to preview yet.';
  }
  if (statusCode === 404) {
    return 'The canvas preview file could not be found.';
  }
  return 'Unable to load canvas preview.';
}

function getErrorStatusCode(error: unknown): number | null {
  if (typeof error !== 'object' || error == null || !('status' in error)) {
    return null;
  }
  const {status} = error;
  return typeof status === 'number' ? status : null;
}
